/**
 * Attaches swipe detection to a container, ignoring swipes from scrollable zones.
 * @param {HTMLElement} element - Element to attach listeners on
 * @param {Object} handlers
 * @param {Function} [handlers.onSwipeLeft]  - Callback on left swipe
 * @param {Function} [handlers.onSwipeRight] - Callback on right swipe
 */
export function detectSwipe(element, { onSwipeLeft, onSwipeRight }) {
	let touchStartX = 0;
	let touchEndX = 0;
	let skipSwipe = false;

	element.addEventListener('touchstart', (e) => {
		touchStartX = e.changedTouches[0].screenX;

		// Skip swipe handling if the gesture starts inside a horizontally scrollable container
		skipSwipe = e.target.closest('.tab') !== null;
	});

	element.addEventListener('touchend', (e) => {
		if (skipSwipe) return;

		touchEndX = e.changedTouches[0].screenX;
		handleSwipe();
	});

	function handleSwipe() {
		const deltaX = touchEndX - touchStartX;

		// Define threshold to avoid accidental triggers
		if (Math.abs(deltaX) < 50) return;

		if (deltaX > 0 && typeof onSwipeRight === 'function') {
			onSwipeRight();
		} else if (deltaX < 0 && typeof onSwipeLeft === 'function') {
			onSwipeLeft();
		}
	}
}